import ProductDescription from './ProductDescription'

const BSWholeWheatNaanProduct = {
  ...ProductDescription,
  category: '16',
  subCategory: '013',
  IsBroadband: true,
  Size: '',
}

export default BSWholeWheatNaanProduct
